module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-2x"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalHeaderTitle')) + " " + _vm._s(_vm.groupName))]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "client-group-modal-list"
  }, _vm._l((_vm.clients), function(client, key) {
    return _c('li', [_c('span', [_vm._v(_vm._s(client.name))]), _vm._v(" "), _c('ul', {
      staticClass: "client-group-modal-list-child"
    }, _vm._l((client.contacts), function(contact, key2) {
      return _c('li', [(contact.exist) ? _c('p', [_vm._v("\n                    " + _vm._s(contact.email) + " \n                    (" + _vm._s((contact.contact_types[0]) ? contact.contact_types[0].name : 'Primary') + ")\n                    " + _vm._s(_vm.$t('static.subscriberList.edit.subscribers.alreadyInList')) + "\n                  ")]) : _c('el-checkbox', {
        attrs: {
          "checked": "",
          "name": 'contact-' + contact.id
        },
        model: {
          value: (_vm.selectedContact[contact.id]),
          callback: function($$v) {
            _vm.$set(_vm.selectedContact, contact.id, $$v)
          },
          expression: "selectedContact[contact.id]"
        }
      }, [_c('span', {
        attrs: {
          "for": 'contact-' + contact.id
        }
      }, [_vm._v("\n                      " + _vm._s(contact.email) + " \n                      (" + _vm._s((contact.contact_types[0]) ? contact.contact_types[0].name : 'Primary') + ")\n                  ")])])], 1)
    }), 0)])
  }), 0)])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalCancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalApply')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1775b32b","hasScoped":false}!./src/app/components/clientGroupModal/clientGroupModal.html
// module id = 2925
// module chunks = 1